var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPininterestWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.477.25C2.925.25.126 4.212.126 7.518c0 2 .76 3.78 2.393 4.443.268.11.507.004.585-.291.054-.204.182-.719.238-.934.08-.291.049-.394-.167-.648-.472-.552-.772-1.268-.772-2.281 0-2.94 2.21-5.571 5.753-5.571 3.138 0 4.861 1.909 4.861 4.457 0 3.355-1.49 6.185-3.704 6.185-1.222 0-2.137-1.007-1.844-2.24C7.82 9.164 8.5 7.573 8.5 6.51c0-.952-.513-1.747-1.576-1.747-1.248 0-2.252 1.288-2.252 3.011 0 1.1.372 1.842.372 1.842l-1.503 6.338c-.446 1.88-.066 4.187-.034 4.421.019.137.196.17.277.067.115-.151 1.604-1.98 2.11-3.808.143-.517.821-3.197.821-3.197.406.77 1.593 1.45 2.854 1.45 3.757 0 6.305-3.41 6.305-7.973 0-3.45-2.935-6.664-7.397-6.664z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "img/_/_/views/utils/components/Footer/assets/svg/pininterest-white.svg";
export { SvgPininterestWhite as ReactComponent };